import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import { Layout } from './Layout';

interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { state } = useApp();
  const location = useLocation();

  // Not unlocked, redirect to login
  if (!state.auth.isUnlocked) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Authenticated, render with layout
  return <Layout>{children}</Layout>;
}